import script from "./AlternativeCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./AlternativeCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./AlternativeCheckbox.vue?vue&type=style&index=0&id=60996f3c&lang=scss&scoped=true"

import exportComponent from "/builds/intranet/intranet/vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60996f3c"]])

export default __exports__